const ProcTypeEnum = {
  NULL: 0,
  0: 'NULL',

  // sales order index
  SLS_ORD_01: 1,
  1: 'SLS_ORD_01',

  // sales order -> outbound order
  OUTB_ORD_01: 2,
  2: 'OUTB_ORD_01',

  // outbound order -> delivery order
  DEL_ORD_01: 3,
  3: 'DEL_ORD_01',

  // export delivery order or return receipt to Microsoft AX, csv
  DEL_ORD_F_SERV_01: 33,
  33: 'DEL_ORD_F_SERV_01',

  RESET_DEL_ORD_F_SERV_01: 35,
  35: 'RESET_DEL_ORD_F_SERV_01',

  // export delivery order to efichain
  DEL_ORD_SYNC_01: 46,
  46: 'DEL_ORD_SYNC_01',

  RESET_DEL_ORD_SYNC_01: 47,
  47: 'RESET_DEL_ORD_SYNC_01',

  // outbound order -> sales invoice
  SLS_INV_01: 4,
  4: 'SLS_INV_01',

  // DO, PRF -> sales invoice
  SLS_INV_02: 5,
  5: 'SLS_INV_02',

  // outbound order -> picking list
  PICK_LIST_01: 6,
  6: 'PICK_LIST_01',

  // DRAFT to WIP, PRINT PICK_LIST, skip the wip pick list process
  PICK_LIST_01_01: 119,
  119: 'PICK_LIST_01_01',

  // Pending PickList, print outbOrd summary
  PICK_LIST_01_02: 149,
  149: 'PICK_LIST_01_02',

  // OutbOrd -> PackList, list by loading bay bin
  PACK_LIST_01: 7,
  7: 'PACK_LIST_01',

  // Pick List, DO/INV -> loading list (gds iss), DO
  LOAD_LIST_01: 9,
  9: 'LOAD_LIST_01',

  // batch print load list, not printed
  LOAD_LIST_01_01: 29,
  29: 'LOAD_LIST_01_01',

  // Pack List, DO/INV -> loading list (gds iss), DO
  LOAD_LIST_02: 10,
  10: 'LOAD_LIST_02',

  LOAD_LIST_SYNC_01: 37,
  37: 'LOAD_LIST_SYNC_01',

  RESET_LOAD_LIST_SYNC_01: 39,
  39: 'RESET_LOAD_LIST_SYNC_01',

  // DO/INV -> proof of delivery
  PRF_DEL_01: 11,
  11: 'PRF_DEL_01',

  PRF_DEL_SYNC_01: 38,
  38: 'PRF_DEL_SYNC_01',

  RESET_PRF_DEL_SYNC_01: 40,
  40: 'RESET_PRF_DEL_SYNC_01',

  // DO/INV -> failed delivery (gds rcpt)
  FAIL_DEL_01: 12,
  12: 'FAIL_DEL_01',

  // pick list -> inventory docs (D/O, Invoice)
  INV_DOC_01: 13,
  13: 'INV_DOC_01',

  // batch print inventory docs (D/O, Invoice)
  INV_DOC_01_01: 14,
  14: 'INV_DOC_01_01',

  // batch reprint inventory docs (D/O, Invoice)
  INV_DOC_01_02: 18,
  18: 'INV_DOC_01_02',

  // return receipt -> inventory docs (RTN_RCPT/CN)
  INV_DOC_02: 21,
  21: 'INV_DOC_02',

  // goods receipt -> purchase invoice/stock issue
  INV_DOC_03: 31,
  31: 'INV_DOC_03',

  // import sales order from efichain, by division
  SLS_ORD_SYNC_01: 15,
  15: 'SLS_ORD_SYNC_01',

  // import autocount sales invoice from excel, by division
  SLS_ORD_EXCEL_01: 30,
  30: 'SLS_ORD_EXCEL_01',

  // import Microsoft AX sales invoice from csv, by division
  SLS_ORD_F_SERV_01: 32,
  32: 'SLS_ORD_F_SERV_01',

  // export voided sales order to Microsoft AX, by division
  SLS_ORD_F_SERV_02: 34,
  34: 'SLS_ORD_F_SERV_02',

  RESET_SLS_ORD_F_SERV_02: 43,
  43: 'RESET_SLS_ORD_F_SERV_02',

  SLS_RTN_F_SERV_02: 44,
  44: 'SLS_RTN_F_SERV_02',

  RESET_SLS_RTN_F_SERV_02: 45,
  45: 'RESET_SLS_RTN_F_SERV_02',

  // export pick list to efichain, by user's division
  PICK_LIST_SYNC_01: 16,
  16: 'PICK_LIST_SYNC_01',

  // export sls inv to efichain, by user's division
  SLS_INV_SYNC_01: 17,
  17: 'SLS_INV_SYNC_01',

  RESET_SLS_INV_SYNC_01: 41,
  41: 'RESET_SLS_INV_SYNC_01',

  SLS_RTN_SYNC_01: 19,
  19: 'SLS_RTN_SYNC_01',

  // inbOrd -> rtnRcpt
  RTN_RCPT_01: 22,
  22: 'RTN_RCPT_01',

  RTN_RCPT_SYNC_01: 20,
  20: 'RTN_RCPT_SYNC_01',

  RESET_RTN_RCPT_SYNC_01: 42,
  42: 'RESET_RTN_RCPT_SYNC_01',

  // import lsp sls order from csv file, service based, company_id based on debtor_id (principal)
  LSP_SLS_ORD_EXCEL_01: 23,
  23: 'LSP_SLS_ORD_EXCEL_01',

  // lsp sales order -> outbound order
  OUTB_ORD_02: 24,
  24: 'OUTB_ORD_02',

  LSP_DEL_ORD_01: 28,
  28: 'LSP_DEL_ORD_01',

  LSP_SLS_RTN_EXCEL_01: 25,
  25: 'LSP_SLS_RTN_EXCEL_01',

  // LSP_SLS_RTN -> INB_ORD
  INB_ORD_04: 26,
  26: 'INB_ORD_04',

  // INB_ORD -> LSP_RTN_RCPT
  LSP_RTN_RCPT_01: 27,
  27: 'LSP_RTN_RCPT_01',

  // PO
  PUR_ORD_01: 100,
  100: 'PUR_ORD_01',

  // PUR_RTN -> OUTB_ORD
  OUTB_ORD_08: 126,
  126: 'OUTB_ORD_08',

  // OUTB_ORD -> RTN_DEL
  RTN_DEL_01: 128,
  128: 'RTN_DEL_01',

  GDS_ISS_01: 127,
  127: 'GDS_ISS_01',

  GDS_ISS_01_01: 129,
  129: 'GDS_ISS_01_01',

  // export goods receipt/purchase return to Microsoft AX, csv
  GDS_ISS_F_SERV_01: 130,
  130: 'GDS_ISS_F_SERV_01',

  RESET_GDS_ISS_F_SERV_01: 140,
  140: 'RESET_GDS_ISS_F_SERV_01',

  // export stock receipt to Microsoft AX, csv
  GDS_ISS_F_SERV_02: 132,
  132: 'GDS_ISS_F_SERV_02',

  // export purchase receipt to Efichain
  GDS_ISS_SYNC_01: 147,
  147: 'GDS_ISS_SYNC_01',

  // import purchase invoice from efichain, by division
  ADV_SHIP_SYNC_01: 108,
  108: 'ADV_SHIP_SYNC_01',

  // import GRN from efichain, by division
  ADV_SHIP_SYNC_02: 121,
  121: 'ADV_SHIP_SYNC_02',

  // import purchase order from efichain, by division
  ADV_SHIP_SYNC_03: 144,
  144: 'ADV_SHIP_SYNC_03',

  // import autocount ADV_SHIP from excel, by division
  ADV_SHIP_EXCEL_01: 120,
  120: 'ADV_SHIP_EXCEL_01',

  // import Microsoft AX advanced shipment from csv, by division
  ADV_SHIP_F_SERV_01: 124,
  124: 'ADV_SHIP_F_SERV_01',

  // export cancelled order to Microsoft AX, by division
  ADV_SHIP_F_SERV_02: 135,
  135: 'ADV_SHIP_F_SERV_02',

  RESET_ADV_SHIP_F_SERV_02: 136,
  136: 'RESET_ADV_SHIP_F_SERV_02',

  PUR_RTN_F_SERV_02: 141,
  141: 'PUR_RTN_F_SERV_02',

  // import purchase invoice from efichain, by division
  PUR_RTN_SYNC_01: 145,
  145: 'PUR_RTN_SYNC_01',

  RESET_PUR_RTN_F_SERV_02: 142,
  142: 'RESET_PUR_RTN_F_SERV_02',

  // ADV_SHIP
  ADV_SHIP_01: 101,
  101: 'ADV_SHIP_01',

  // ADV_SHIP -> INB_ORD
  INB_ORD_01: 102,
  102: 'INB_ORD_01',

  // SLS_RTN -> INB_ORD
  INB_ORD_02: 103,
  103: 'INB_ORD_02',

  // INB_ORD -> GDS_RCPT, pre assigned the receiving bay bin, ADV_SHIP
  GDS_RCPT_01: 104,
  104: 'GDS_RCPT_01',

  // DRAFT to COMPLETE, PRINT GDS_RCPT, skip the put away process
  GDS_RCPT_01_01: 118,
  118: 'GDS_RCPT_01_01',

  // INB_ORD -> GDS_RCPT, SLS_RTN
  GDS_RCPT_02: 109,
  109: 'GDS_RCPT_02',

  // INB_ORD -> GDS_RCPT, pre assigned the receiving bay bin, for cross docking purpose, ADV_SHIP
  GDS_RCPT_03: 111,
  111: 'GDS_RCPT_03',

  // WIP GDS_RCPT, SLS_RTN
  GDS_RCPT_02_01: 110,
  110: 'GDS_RCPT_02_01',

  // Pending GdsRcpt, print inbOrd summary
  GDS_RCPT_02_02: 148,
  148: 'GDS_RCPT_02_02',

  // export goods receipt/purchase return to Microsoft AX, csv
  GDS_RCPT_F_SERV_01: 125,
  125: 'GDS_RCPT_F_SERV_01',

  GDS_RCPT_F_SERV_01_NO_PUTAWAY: 1250,
  1250: 'GDS_RCPT_F_SERV_01_NO_PUTAWAY',

  // export purchase receipt to Efichain
  GDS_RCPT_SYNC_01: 146,
  146: 'GDS_RCPT_SYNC_01',

  RESET_GDS_RCPT_F_SERV_01: 137,
  137: 'RESET_GDS_RCPT_F_SERV_01',

  // export transfer order/stock receipt to Microsoft AX, csv
  GDS_RCPT_F_SERV_02: 131,
  131: 'GDS_RCPT_F_SERV_02',

  RESET_GDS_RCPT_F_SERV_02: 138,
  138: 'RESET_GDS_RCPT_F_SERV_02',

  // export gdsRcpt (sales return) to AX, by user's division
  GDS_RCPT_F_SERV_03: 327,
  327: 'GDS_RCPT_F_SERV_03',

  // GDS_RCPT -> PUT AWAY
  PUT_AWAY_01: 105,
  105: 'PUT_AWAY_01',

  // GDS_RCPT -> PUT AWAY
  PUT_AWAY_02: 143,
  143: 'PUT_AWAY_02',

  // PROD_SHEET -> PUT AWAY
  PUT_AWAY_03: 133,
  133: 'PUT_AWAY_03',

  // export put away(ASN as parent) to efichain
  PUT_AWAY_SYNC_01: 122,
  122: 'PUT_AWAY_SYNC_01',

  RESET_PUT_AWAY_SYNC_01: 123,
  123: 'RESET_PUT_AWAY_SYNC_01',

  // export production put away to Microsoft AX, csv
  PUT_AWAY_F_SERV_01: 134,
  134: 'PUT_AWAY_F_SERV_01',

  RESET_PUT_AWAY_F_SERV_01: 139,
  139: 'RESET_PUT_AWAY_F_SERV_01',

  // GDS_RCPT, ADV_SHIP -> PI
  PUR_INV_01: 106,
  106: 'PUR_INV_01',

  // verify pur inv
  PUR_INV_01_01: 107,
  107: 'PUR_INV_01_01',

  // import lst advanced shipment from csv, by division
  LSP_ADV_SHIP_EXCEL_01: 112,
  112: 'LSP_ADV_SHIP_EXCEL_01',

  // LSP_ADV_SHIP -> INB_ORD
  INB_ORD_03: 113,
  113: 'INB_ORD_03',

  // INB_ORD -> LSP_PUR_RCPT
  LSP_PUR_RCPT_01: 116,
  116: 'LSP_PUR_RCPT_01',

  // import lst purchase return from csv, by division
  LSP_PUR_RTN_EXCEL_01: 114,
  114: 'LSP_PUR_RTN_EXCEL_01',

  // lsp pur rtn -> outbound order
  OUTB_ORD_03: 115,
  115: 'OUTB_ORD_03',

  // OUTB_ORD -> LSP_RTN_DEL
  LSP_RTN_DEL_01: 117,
  117: 'LSP_RTN_DEL_01',

  // CYCLE_COUNT, BIN BASED CYCLE COUNT
  CYCLE_COUNT_01: 200,
  200: 'CYCLE_COUNT_01',

  // CYCLE_COUNT, BIN BASED CYCLE COUNT, ADD NEW WITH CRITERIA
  CYCLE_COUNT_01_01: 208,
  208: 'CYCLE_COUNT_01_01',

  // CYCLE_RECOUNT, RECOUNT, BIN BASED CYCLE COUNT
  CYCLE_COUNT_02: 201,
  201: 'CYCLE_COUNT_02',

  // CYCLE_COUNT, GROUP CYCLE COUNT
  CYCLE_COUNT_03: 203,
  203: 'CYCLE_COUNT_03',

  // import cycle count details from excel
  CYCLE_COUNT_EXCEL_01: 205,
  205: 'CYCLE_COUNT_EXCEL_01',

  CYCLE_COUNT_DETAILS: 210,
  210: 'CYCLE_COUNT_DETAILS',

  // COUNT_ADJ, CYCLE COUNT -> COUNT ADJUSTMENT
  COUNT_ADJ_01: 204,
  204: 'COUNT_ADJ_01',

  COUNT_ADJ_SYNC_01: 213,
  213: 'COUNT_ADJ_SYNC_01',

  // export location adjustment
  COUNT_ADJ_SYNC_02: 222,
  222: 'COUNT_ADJ_SYNC_02',

  RESET_COUNT_ADJ_SYNC_01: 214,
  214: 'RESET_COUNT_ADJ_SYNC_01',

  COUNT_ADJ_F_SERV_01: 216,
  216: 'COUNT_ADJ_F_SERV_01',

  RESET_COUNT_ADJ_F_SERV_01: 220,
  220: 'RESET_COUNT_ADJ_F_SERV_01',

  // export location adjustment
  COUNT_ADJ_F_SERV_02: 221,
  221: 'COUNT_ADJ_F_SERV_02',

  // PROD_SHEET, PROD_ISS -> PROD_SHEET, COUNT_ADJ FOR MANUFACTURING
  PROD_SHEET_01: 211,
  211: 'PROD_SHEET_01',

  PROD_SHEET_F_SERV_01: 218,
  218: 'PROD_SHEET_F_SERV_01',

  RESET_PROD_SHEET_F_SERV_01: 219,
  219: 'RESET_PROD_SHEET_F_SERV_01',

  COUNT_ADJ_DETAILS: 209,
  209: 'COUNT_ADJ_DETAILS',

  BIN_TRF_DETAILS: 217,
  217: 'BIN_TRF_DETAILS',

  // BIN_TRF, PICK FACE REPLENISHMENT
  BIN_TRF_01: 206,
  206: 'BIN_TRF_01',

  BIN_TRF_EXCEL_01: 215,
  215: 'BIN_TRF_EXCEL_01',

  // BIN_TRF, BIN TRANSFER
  BIN_TRF_02: 207,
  207: 'BIN_TRF_02',

  // BIN_TRF, MANUFACTURING TRANSFER
  BIN_TRF_03: 212,
  212: 'BIN_TRF_03',

  // TRF_ORD, STOCK TRANSFER
  TRF_ORD_01: 300,
  300: 'TRF_ORD_01',

  // Site Transfer, TRF_ORD -> OUTB_ORD
  OUTB_ORD_05: 301,
  301: 'OUTB_ORD_05',

  // Transfer To Store, TRF_ORD -> OUTB_ORD
  OUTB_ORD_06: 306,
  306: 'OUTB_ORD_06',

  // Transfer To Van, TRF_ORD -> OUTB_ORD
  OUTB_ORD_07: 307,
  307: 'OUTB_ORD_07',

  // Site Transfer, outbound order -> stock issue
  STK_ISS_01: 302,
  302: 'STK_ISS_01',

  // Transfer To Store, outbound order -> stock issue
  STK_ISS_02: 322,
  322: 'STK_ISS_02',

  // Transfer To Van, outbound order -> stock issue
  STK_ISS_03: 310,
  310: 'STK_ISS_03',

  // Site Transfer, export site stock issue to efichain, by user's division
  STK_ISS_SYNC_01: 305,
  305: 'STK_ISS_SYNC_01',

  // Transfer To Store, export stock issue to efichain, by user's division
  STK_ISS_SYNC_02: 323,
  323: 'STK_ISS_SYNC_02',

  // Transfer To Van, export stock issue to efichain, by user's division
  STK_ISS_SYNC_03: 324,
  324: 'STK_ISS_SYNC_03',

  // Transfer From Store, export stock issue to efichain, by user's division
  STK_ISS_SYNC_04: 325,
  325: 'STK_ISS_SYNC_04',

  // Transfer From Van, export stock issue to efichain, by user's division
  STK_ISS_SYNC_05: 326,
  326: 'STK_ISS_SYNC_05',

  // Site Transfer/Transfer to Store, export transfer order to AX
  STK_ISS_F_SERV_01: 328,
  328: 'STK_ISS_F_SERV_01',

  RESET_STK_ISS_F_SERV_01: 329,
  329: 'RESET_STK_ISS_F_SERV_01',

  // Site Transfer, STK_ISS -> INB_ORD
  INB_ORD_05: 303,
  303: 'INB_ORD_05',

  // Transfer From Store, TRF_ORD -> INB_ORD
  INB_ORD_06: 314,
  314: 'INB_ORD_06',

  // Transfer From Van, TRF_ORD -> INB_ORD
  INB_ORD_07: 315,
  315: 'INB_ORD_07',

  // Site Transfer, inbound order -> stock receipt
  STK_RCPT_01: 304,
  304: 'STK_RCPT_01',

  // Transfer To Store, inbound order -> stock receipt
  STK_RCPT_02: 316,
  316: 'STK_RCPT_02',

  // Transfer To Van, stock issue -> stock receipt
  STK_RCPT_03: 309,
  309: 'STK_RCPT_03',

  // Transfer From Store, inbound order -> stock receipt
  STK_RCPT_04: 317,
  317: 'STK_RCPT_04',

  // Transfer From Van, stock issue -> stock receipt
  STK_RCPT_05: 318,
  318: 'STK_RCPT_05',

  // Site Transfer, export site stock receipt to efichain, by user's division
  STK_RCPT_SYNC_01: 308,
  308: 'STK_RCPT_SYNC_01',

  // Transfer To Store, export stock receipt to efichain, by user's division
  STK_RCPT_SYNC_02: 319,
  319: 'STK_RCPT_SYNC_02',

  // Transfer To Van, export stock receipt to efichain, by user's division
  STK_RCPT_SYNC_03: 311,
  311: 'STK_RCPT_SYNC_03',

  // Transfer From Store, export stock receipt to efichain, by user's division
  STK_RCPT_SYNC_04: 320,
  320: 'STK_RCPT_SYNC_04',

  // Transfer From Van, export stock receipt to efichain, by user's division
  STK_RCPT_SYNC_05: 321,
  321: 'STK_RCPT_SYNC_05',

  // Transfer To Van, outbound order -> stock transfer
  STK_TRF_01: 312,
  312: 'STK_TRF_01',

  // Transfer To Van, export van stock transfer to efichain, by user's division
  STK_TRF_SYNC_01: 313,
  313: 'STK_TRF_SYNC_01',

  // all item listing, stock item only
  ITEM_LIST_01: 1000,
  1000: 'ITEM_LIST_01',

  // all item listing, non stock item
  ITEM_LIST_02: 1018,
  1018: 'ITEM_LIST_02',

  // all item excel
  ITEM_EXCEL_01: 1001,
  1001: 'ITEM_EXCEL_01',

  // all item excel
  ITEM_BATCH_EXCEL_01: 1037,
  1037: 'ITEM_BATCH_EXCEL_01',

  // sync all item EfiChain
  ITEM_SYNC_01: 1002,
  1002: 'ITEM_SYNC_01',

  // sync all item photos
  ITEM_SYNC_01_01: 1003,
  1003: 'ITEM_SYNC_01_01',

  // download all item photos from local folder
  ITEM_SYNC_01_02: 1009,
  1009: 'ITEM_SYNC_01_02',

  STORAGE_BIN_LIST_01: 1004,
  1004: 'STORAGE_BIN_LIST_01',

  LOCATION_LIST_01: 1034,
  1034: 'LOCATION_LIST_01',

  STORAGE_ROW_LIST_01: 1023,
  1023: 'STORAGE_ROW_LIST_01',

  STORAGE_BAY_LIST_01: 1024,
  1024: 'STORAGE_BAY_LIST_01',

  STORAGE_TYPE_LIST_01: 1042,
  1042: 'STORAGE_TYPE_LIST_01',

  WHSE_TXN_FLOW: 1029,
  1029: 'WHSE_TXN_FLOW',

  PRINT_DOC_SETTING: 1030,
  1030: 'PRINT_DOC_SETTING',

  USER_DIVISION: 1032,
  1032: 'USER_DIVISION',

  // warehouse map
  STORAGE_BIN_LIST_02: 1010,
  1010: 'STORAGE_BIN_LIST_02',

  STORAGE_BIN_EXCEL_01: 1005,
  1005: 'STORAGE_BIN_EXCEL_01',

  DELIVERY_POINT_LIST_01: 1006,
  1006: 'DELIVERY_POINT_LIST_01',

  DELIVERY_POINT_SYNC_01: 1007,
  1007: 'DELIVERY_POINT_SYNC_01',

  // list all pallet label
  HANDLING_UNIT_LIST_01: 1008,
  1008: 'HANDLING_UNIT_LIST_01',

  // list pallet label by gdsRcpt whseJob
  HANDLING_UNIT_LIST_02: 1011,
  1011: 'HANDLING_UNIT_LIST_02',

  // list pallet label by putAway whseJob
  HANDLING_UNIT_LIST_03: 1019,
  1019: 'HANDLING_UNIT_LIST_03',

  // list pallet label by gdsRcpt whseJob (return)
  HANDLING_UNIT_LIST_02_02: 1040,
  1040: 'HANDLING_UNIT_LIST_05',

  // list pallet label by putAway whseJob (return)
  HANDLING_UNIT_LIST_03_02: 1041,
  1041: 'HANDLING_UNIT_LIST_06',

  // list pallet label by gdsRcpt
  HANDLING_UNIT_LIST_04: 1022,
  1022: 'HANDLING_UNIT_LIST_04',

  PICK_FACE_STRATEGY_LIST_01: 1012,
  1012: 'PICK_FACE_STRATEGY_LIST_01',

  PICK_FACE_STRATEGY_EXCEL_01: 1013,
  1013: 'PICK_FACE_STRATEGY_EXCEL_01',

  PICKING_CRITERIA_LIST_01: 1038,
  1038: 'PICKING_CRITERIA_LIST_01',

  PICKING_CRITERIA_EXCEL_01: 1039,
  1039: 'PICKING_CRITERIA_EXCEL_01',

  // wms role listing
  ROLE_LIST_01: 1014,
  1014: 'ROLE_LIST_01',

  // wms role excel
  ROLE_EXCEL_01: 1015,
  1015: 'ROLE_EXCEL_01',

  // wms user listing
  USER_LIST_01: 1016,
  1016: 'USER_LIST_01',

  // wms user excel
  USER_EXCEL_01: 1017,
  1017: 'USER_EXCEL_01',

  SITE_LIST_01: 1027,
  1027: 'SITE_LIST_01',

  SITE_FLOW_LIST_01: 1028,
  1028: 'SITE_FLOW_LIST_01',

  DIVISION_LIST_01: 1031,
  1031: 'DIVISION_LIST_01',

  COMPANY_LIST_01: 1033,
  1033: 'COMPANY_LIST_01',

  // principal
  PRINCIPAL_LIST_01: 1020,
  1020: 'PRINCIPAL_LIST_01',

  // debtor
  DEBTOR_LIST_01: 1025,
  1025: 'DEBTOR_LIST_01',

  // creditor
  CREDITOR_LIST_01: 1026,
  1026: 'CREDITOR_LIST_01',

  // transport
  TRANSPORT_LIST_01: 1021,
  1021: 'TRANSPORT_LIST_01',

  // area
  AREA_LIST_01: 1035,
  1035: 'AREA_LIST_01',

  PROJECT_LIST_01: 1036,
  1036: 'PROJECT_LIST_01',

  COUNT_ADJ_REASON_LIST_01: 1043,
  1043: 'COUNT_ADJ_REASON_LIST_01',

  // import autocount PROD_ORD from excel, by division
  PROD_ORD_EXCEL_01: 2000,
  2000: 'PROD_ORD_EXCEL_01',

  // PRODUCTION MODULE, PROD_ORD -> OUTB_ORD
  OUTB_ORD_04: 2001,
  2001: 'OUTB_ORD_04',

  // PRODUCTION MODULE, OUTB_ORD -> stock issue
  PROD_ISS: 2002,
  2002: 'PROD_ISS',

  // PRODUCTION MODULE, INB_ORD -> stock rcpt
  PROD_RCPT: 2003,
  2003: 'PROD_RCPT',

  // import Microsoft AX sales invoice from csv, by division
  PROD_ORD_F_SERV_01: 2004,
  2004: 'PROD_ORD_F_SERV_01',

  // export delivery order or return receipt to Microsoft AX, csv
  PROD_ISS_F_SERV_01: 2005,
  2005: 'PROD_ISS_F_SERV_01',

  // export cancelled order to Microsoft AX, by division
  PROD_ORD_F_SERV_02: 2006,
  2006: 'PROD_ORD_F_SERV_02',

  RESET_PROD_ORD_F_SERV_02: 2007,
  2007: 'RESET_PROD_ORD_F_SERV_02',

  RESET_PROD_ISS_F_SERV_01: 2008,
  2008: 'RESET_PROD_ISS_F_SERV_01',

  // WORK ORD
  WORK_ORD: 2009,
  2009: 'WORK_ORD',

  // CPS REPORT
  DOWNLOAD_PROD_RCPT_REPORT: 2010,
  2010: 'DOWNLOAD_PROD_RCPT_REPORT',

  LAYER_FARM_LIST: 2011,
  2011: 'LAYER_FARM_LIST',

  LAYER_FARM_EXCEL: 2012,
  2012: 'LAYER_FARM_EXCEL',

  DOWNLOAD_LAYER_FARM: 2013,
  2013: 'DOWNLOAD_LAYER_FARM',

  UPLOAD_LAYER_FARM: 2014,
  2014: 'UPLOAD_LAYER_FARM',

  DOWNLOAD_VARIANCE_REPORT: 2015,
  2015: 'DOWNLOAD_VARIANCE_REPORT',

  DOWNLOAD_FINISHED_ITEM_REPORT: 2016,
  2016: 'DOWNLOAD_FINISHED_ITEM_REPORT',

  DOWNLOAD_MATERIAL_REPORT: 2017,
  2017: 'DOWNLOAD_MATERIAL_REPORT',

  EXPORT_AX_CPS: 2018,
  2018: 'EXPORT_AX_CPS',

  DOWNLOAD_AX_CPS: 2019,
  2019: 'DOWNLOAD_AX_CPS',

  DOWNLOAD_MGR_CPS_REPORT: 2020,
  2020: 'DOWNLOAD_MGR_CPS_REPORT',

  DOWNLOAD_TRANSFER_IN_REPORT: 2021,
  2021: 'DOWNLOAD_TRANSFER_IN_REPORT',

  DOWNLOAD_TRANSFER_OUT_REPORT: 2022,
  2022: 'DOWNLOAD_TRANSFER_OUT_REPORT',

  DOWNLOAD_GRADING_MACHINE: 2023,
  2023: 'DOWNLOAD_GRADING_MACHINE',

  GRADING_MACHINE_LIST: 2024,
  2024: 'GRADING_MACHINE_LIST',

  GRADING_MACHINE_EXCEL: 2025,
  2025: 'GRADING_MACHINE_EXCEL',

  UPLOAD_GRADING_MACHINE: 2026,
  2026: 'UPLOAD_GRADING_MACHINE',

  DOWNLOAD_OPENING_BALANCE: 2027,
  2027: 'DOWNLOAD_OPENING_BALANCE',

  UPLOAD_OPENING_BALANCE: 2028,
  2028: 'UPLOAD_OPENING_BALANCE',

  PCN_SYNC_SETTING: 2029,
  2029: 'PCN_SYNC_SETTING',

  // create pick list whse job, 1 pick list = 1n whse job, 03 is pick list ResType
  WHSE_JOB_03_01: 10000,
  10000: 'WHSE_JOB_03_01',

  // print pick list whse job
  WHSE_JOB_03_01_01: 10001,
  10001: 'WHSE_JOB_03_01_01',

  // print pick list whse job by pick list
  WHSE_JOB_03_01_02: 10016,
  10016: 'WHSE_JOB_03_01_02',

  // create pack list whse job, count by picking list, 05 is pack list ResType
  WHSE_JOB_05_01: 10002,
  10002: 'WHSE_JOB_05_01',

  // execute pack list whse job
  WHSE_JOB_05_01_01: 10003,
  10003: 'WHSE_JOB_05_01_01',

  // create pack list whse job, pack by outb ord, 05 is pack list ResType
  WHSE_JOB_05_02: 10004,
  10004: 'WHSE_JOB_05_02',

  // execute pack list whse job
  WHSE_JOB_05_02_01: 10005,
  10005: 'WHSE_JOB_05_02_01',

  // create load list whse job, load by outb ord, 06 is load list ResType
  WHSE_JOB_06_01: 10006,
  10006: 'WHSE_JOB_06_01',

  // execute load list whse job
  WHSE_JOB_06_01_01: 10007,
  10007: 'WHSE_JOB_06_01_01',

  // create load list whse job, 1 outb ord = 1 whse job, 06 is load list ResType
  WHSE_JOB_06_02: 10024,
  10024: 'WHSE_JOB_06_02',

  // execute load list whse job, 1 outb ord = 1 whse job
  WHSE_JOB_06_02_01: 10025,
  10025: 'WHSE_JOB_06_02_01',

  // create gds rcpt whse job, 14 is gds rcpt ResType
  WHSE_JOB_14_01: 10008,
  10008: 'WHSE_JOB_14_01',

  // execute gds rcpt whse job
  WHSE_JOB_14_01_01: 10009,
  10009: 'WHSE_JOB_14_01_01',

  // create gds rcpt whse job, sls rtn, 14 is gds rcpt ResType
  WHSE_JOB_14_02: 10017,
  10017: 'WHSE_JOB_14_02',

  // execute gds rcpt whse job, sls rtn
  WHSE_JOB_14_02_01: 10018,
  10018: 'WHSE_JOB_14_02_01',

  // create put away whse job, 1 put away = 1 whse job, 15 is put away ResType
  WHSE_JOB_15_01: 10010,
  10010: 'WHSE_JOB_15_01',

  // create put away (return) whse job, 1 put away = 1 whse job, 15 is put away (return) ResType
  WHSE_JOB_15_02: 10022,
  10022: 'WHSE_JOB_15_02',

  // execute put away whse job
  WHSE_JOB_15_01_01: 10011,
  10011: 'WHSE_JOB_15_01_01',

  // execute put away whse job
  WHSE_JOB_15_02_01: 10023,
  10023: 'WHSE_JOB_15_02_01',

  // create cycle count whse job, 16 is cycle count ResType
  WHSE_JOB_16_01: 10012,
  10012: 'WHSE_JOB_16_01',

  // print cycle count whse job
  WHSE_JOB_16_01_01: 10013,
  10013: 'WHSE_JOB_16_01_01',

  // print cycle count whse job, by cycle count
  WHSE_JOB_16_01_02: 10021,
  10021: 'WHSE_JOB_16_01_02',

  // create bin transfer whse job, 17 is bin trf ResType
  WHSE_JOB_17_01: 10014,
  10014: 'WHSE_JOB_17_01',

  // execute bin transfer whse job, 17 is bin trf ResType
  WHSE_JOB_17_01_01: 10015,
  10015: 'WHSE_JOB_17_01_01',

  // bin transfer whse job, mobile free modify
  WHSE_JOB_17_02: 10019,
  10019: 'WHSE_JOB_17_02',

  // wip bin transfer whse job, mobile free modify
  WHSE_JOB_17_02_01: 10020,
  10020: 'WHSE_JOB_17_02_01',

  // SYNC, INTEGRATION - export stock balance
  SYNC_EFICHAIN_01: 20000,
  20000: 'SYNC_EFICHAIN_01',

  // export transaction
  SYNC_EFICHAIN_02: 20001,
  20001: 'SYNC_EFICHAIN_02',

  PUR_ORD_SYNC_01: 20002,
  20002: 'PUR_ORD_SYNC_01',

  // REPORTING - stock balance report
  STOCK_BALANCE: 30000,
  30000: 'STOCK_BALANCE',

  // ITEMS MANUFACTURE
  FINISHED_ITEMS: 30001,
  30001: 'FINISHED_ITEMS',
  SEMI_FINISHED_ITEMS: 30002,
  30002: 'SEMI_FINISHED_ITEMS',
  RAW_MATERIALS: 30003,
  30003: 'RAW_MATERIALS',
  DOWNLOAD_MANUFACTURE_ITEM: 30004,
  30004: 'DOWNLOAD_MANUFACTURE_ITEM',

  // ITEMS BATCHES MANUFACTURE
  DOWNLOAD_MANUFACTURE_ITEM_BATCHES: 30005,
  30005: 'DOWNLOAD_MANUFACTURE_ITEM_BATCHES',
  UPLOAD_MANUFACTURE_ITEM_BATCHES: 30006,
  30006: 'UPLOAD_MANUFACTURE_ITEM_BATCHES',

  // ITEMS DOC NO MANUFACTURE
  DOWNLOAD_MANUFACTURE_ITEM_DOC_NO: 30007,
  30007: 'DOWNLOAD_MANUFACTURE_ITEM_DOC_NO',
  UPLOAD_MANUFACTURE_ITEM_DOC_NO: 30008,
  30008: 'UPLOAD_MANUFACTURE_ITEM_DOC_NO'
};

export default ProcTypeEnum;
